import { render, staticRenderFns } from "./SubjectFollowupCompleted.vue?vue&type=template&id=0815c675&"
import script from "./SubjectFollowupCompleted.vue?vue&type=script&lang=js&"
export * from "./SubjectFollowupCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports